import Typography from '@mui/material/Typography';
import { RHFPercentField } from '@openx/components-core/lib/NumberField/RHFPercentField.tsx';
import type { DealFormData } from '@openx/types/deal.ts';
import { microToPercentWithPrecision } from '@openx/utils/lib/microToPercent.ts';
import type { Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const GLOBAL_DEFAULT_PLATFORM_SHARE = '0.0';

export type OpenXPlatformFeeProps = {
  defaultPlatformShare: null | string | undefined;
  index: number;
};

export const OpenXPlatformFee = ({ defaultPlatformShare, index }: OpenXPlatformFeeProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography data-test="oa-access-partner-heading" sx={{ mt: 3 }} variant="h3">
        {t('OpenX Platform Fee')}
      </Typography>

      <RHFPercentField
        dataTest="platform-share"
        helperText={t('The default OpenX Platform Fee will be overwritten for this deal.')}
        label={t('Percentage of Media')}
        name={`third_party_fees_config.${index}.platform_share` satisfies Path<DealFormData>}
        placeholder={microToPercentWithPrecision(defaultPlatformShare) ?? GLOBAL_DEFAULT_PLATFORM_SHARE}
      />
    </>
  );
};
